import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";
import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader";

/** Backend: POST /approval-videos/sessions */
export async function createSession(params) {
  const axios = axiosInstance().primoLab;
  try {
    const response = await axios.post("/approval-videos/sessions", params);
    return { session: response.data.data };
  } catch (error) {
    throw error.response?.data?.errors ?? error;
  }
}

/** Backend: GET /approval-videos/sessions/{id} */
export async function showSession(sessionId, loading = true) {
  const axios = loading ? axiosInstance().primoLab : axiosInstanceWithoutLoader().primoLab;
  try {
    const response = await axios.get(`/approval-videos/sessions/${sessionId}`);
    return { session: response.data.data };
  } catch (error) {
    throw error.response?.data?.errors ?? error;
  }
}

/** Backend: POST /approval-videos/signed-url */
export async function assignUrl(payload, loading = true) {
  const axios = loading ? axiosInstance().primoLab : axiosInstanceWithoutLoader().primoLab;
  try {
    const response = await axios.post("/approval-videos/signed-url", payload);
    return { data: response.data.data };
  } catch (error) {
    throw error.response?.data?.errors ?? error;
  }
}

/** Backend: POST /approval-videos/sessions/{id}/complete */
export async function completeSession(sessionId, payload = {}, loading = true) {
  const axios = loading ? axiosInstance().primoLab : axiosInstanceWithoutLoader().primoLab;
  try {
    const response = await axios.post(`/approval-videos/sessions/${sessionId}/complete`, payload);
    return { result: response.data.data };
  } catch (error) {
    throw error.response?.data?.errors ?? error;
  }
}
